import { DockviewApi } from 'dockview';
import { TabContext } from '@/entities/tab/model/tab.types';
import { useEffect, useState, useRef } from 'react';

export function usePanelChange(api: DockviewApi | null, panelId: string | null): TabContext | null {
  const [params, setParams] = useState<TabContext | null>(null);
  const lastParamsRef = useRef<string | null>(null);

  useEffect(() => {
    if (!api || !panelId) {
      setParams(null);
      lastParamsRef.current = null;
      return;
    }

    const panel = api.panels.find((p) => p.id === panelId);
    if (panel?.params) {
      const initialParams = panel.params as TabContext;
      setParams(initialParams);
      lastParamsRef.current = JSON.stringify(initialParams);
    }

    const checkParamsChange = () => {
      const panel = api.panels.find((p) => p.id === panelId);
      if (!panel) {
        if (lastParamsRef.current !== null) {
          setParams(null);
          lastParamsRef.current = null;
        }
        return;
      }

      const currentParams = panel.params as TabContext | undefined;
      if (!currentParams) {
        if (lastParamsRef.current !== null) {
          setParams(null);
          lastParamsRef.current = null;
        }
        return;
      }

      const currentParamsStr = JSON.stringify(currentParams);

      if (lastParamsRef.current !== currentParamsStr) {
        setParams(currentParams);
        lastParamsRef.current = currentParamsStr;
      }
    };

    const intervalId = setInterval(checkParamsChange, 50);

    return () => {
      clearInterval(intervalId);
    };
  }, [api, panelId]);

  return params;
}
